import { render, staticRenderFns } from "./LegacyPolicyStudentMap.vue?vue&type=template&id=2f420dfa"
import script from "./LegacyPolicyStudentMap.vue?vue&type=script&lang=js"
export * from "./LegacyPolicyStudentMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports